import React from "react";
import ReportPage from "./ReportPage";

export default function NHISReports() {
  return (
    <ReportPage
      title="NHIS/HMO Reports"
      subtitle="NHIS/HMO deduction schedule."
      endpoint="/reports/statutory/nhis"
      exportName="nhis"
      summaryCards={[
        { key: "total_amount", label: "Total Amount", money: true },
        { key: "staff_count_on_page", label: "Staff Count" },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "item", label: "Item" },
        { key: "amount", label: "Amount" },
      ]}
    />
  );
}
